import { NAVColumnsList } from "../../Pages/Dashboard/NavColumnsList";
import { HeaderSkel } from "../../Pages/Dashboard/ScheletonBlock";
import { Avatar, DarkToggle } from "../MiscComponent/PrimitiveComponent";

export function CustomerHeader ({ loading, tabLoading, isPaid, isPsb, data, dark, setDark, tab, setSidebar }) {

return (<>
    <header className="top-header">
        <button className="btn-ghost d-lg-none" style={{ marginRight:12, padding:"6px 10px" }}
            onClick={()=>setSidebar(true)}>
                <i className="fa fa-list"></i>
            </button>
        {loading ?
        <HeaderSkel /> : (
        <>
            <div>
                <div className="flex items-center gap-2" style={{ marginBottom:2 }}>
                    <span
                        style={{ fontSize:16, fontWeight:700, color:"var(--txt)" }}>{NAVColumnsList.find(n=>n.key === tab)?.label}</span>
                    {tabLoading
                    ?
                    <div
                        style={{ width:14, height:14, borderRadius:99, border:"2px solid var(--accent)", borderTopColor:"transparent", animation:"spin 0.7s linear infinite" }} />
                    : <span className={`badge ${isPsb?"badge-warn":"badge-accent"}`}
                        style={{ fontSize:10 }}>{isPsb?"PSB":"Invoice"}</span>
                    }
                </div>
                <div style={{ fontSize:12, color:"var(--txt3)" }}>
                    {new Date().toLocaleDateString("id-ID",{weekday:"long",day:"numeric",month:"long",year:"numeric"})}
                </div>
            </div>

            <div className="flex items-center gap-3">
                {!isPaid && <span className="badge badge-danger d-none d-sm-flex">Belum Bayar</span>}
                <DarkToggle dark={dark} toggle={()=>setDark(d=>!d)} />
                    <Avatar name={`${data.firstname} ${data.lastname}`} />
            </div>
        </>
        )}
    </header>
</>)
}